module.exports = __webpack_public_path__ + "files/6085ad4aaba610365fd5654d0aa115cc.png";